import { Container, chakra } from "@chakra-ui/react";
import { LinkButton } from "@/components/shared/generic";
import PageInfo from "@/components/PageInfo";
import { TestimonialList } from "@/components/home/Testimonials";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function Testimonials({ testimonials }) {
  return (
    <>
      <PageInfo
        title="Testimonials"
        themeColor="white"
        description="Here's what people are saying about us!"
      />
      <Navbar />

      <Container my={10} textAlign="center">
        <chakra.h1 textStyle="pageHeader" textAlign="center">
          What people are saying...
        </chakra.h1>

        <LinkButton
          mt={10}
          href="https://docs.google.com/forms/d/e/1FAIpQLSfCfCCgmQNXZO-tQyOXbGrQmo-pRuQ702Kjav-IGYWwtipzdA/viewform?usp=send_form"
          target="_blank"
          variant="solid"
          colorScheme="green"
        >
          Submit a testimonial
        </LinkButton>
      </Container>

      <Container pb={10}>
        <TestimonialList
          bg="linear-gradient(38deg, #18173C 17.64%, rgba(83, 22, 60, 0.88) 89.72%)"
          rawTestimonials={testimonials.columns}
        />
      </Container>

      <Footer />
    </>
  );
}

export async function getStaticProps(context) {
  const testimonials = require("@/utils/data/testimonial-data.json");

  return {
    props: { testimonials },
  };
}
